<template>
    <div id="EnCycleBadgeProgress">
        <h1 class="h1 w3 w90-mb">
            Check the application progress <br />
            and status of recycled <br />
            marine debris product label
        </h1>
        <section id="cycle-badge-progress-form" class="w3 w90-mb">
            <ElForm
                ref="progressFormRef"
                :model="progressFormData"
                :rules="progressFormRule"
                label-position="top"
            >
                <ElFormItem
                    label="Document issue number (by the applicant)"
                    prop="unitPublishNumber"
                >
                    <ElInput
                        v-model="progressFormData.unitPublishNumber"
                        placeholder="issue number"
                    ></ElInput>
                </ElFormItem>
                <ElFormItem label="Product name" prop="productName">
                    <ElInput
                        v-model="progressFormData.productName"
                        placeholder="product name"
                    ></ElInput>
                </ElFormItem>
                <ElFormItem>
                    <div
                        class="small-btn"
                        role="button"
                        tabindex="0"
                        @click="submitForm(progressFormRef)"
                        @keypress.enter="submitForm(progressFormRef)"
                    >
                        Search
                    </div>
                </ElFormItem>
            </ElForm>
        </section>
        <section
            v-if="route.query.unitPublishNumber || route.query.productName"
            id="cycle-badge-progress-products"
            class="w2"
        >
            <div v-if="productStampItems.length === 0" class="no-data">
                No Data
            </div>
            <div v-else>
                <div
                    v-for="item in productStampItems"
                    :key="'progress-search-item-' + item.id"
                >
                    <EnProgressSearchItem
                        v-for="index in item.products.length"
                        :item="item"
                        :index="index - 1"
                        :key="'progress-search-item-' + item.id + index"
                    ></EnProgressSearchItem>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'EnCycleBadgeProgress',
}
</script>

<script setup>
import { ref, reactive, defineAsyncComponent } from 'vue-demi'
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router'
const EnProgressSearchItem = defineAsyncComponent(() =>
    import('@/components/en/EnProgressSearchItem.vue')
)
import { ElForm, ElFormItem, ElInput } from 'element-plus'
import '@/style/element'
import { getProductStampData } from '@/service/apis.js'
import { initQueryItems } from '@/utils/query.js'

onBeforeRouteUpdate((to) => {
    initItems(to.query)
    initQueryItems(progressFormData, to.query)
})

const route = useRoute()
const router = useRouter()
const progressFormRef = ref(null)
const progressFormData = reactive({
    unitPublishNumber: '',
    productName: '',
})
initQueryItems(progressFormData)
const progressFormRule = reactive({
    unitPublishNumber: [
        {
            validator: (rule, value, callback) => {
                if (!value && !progressFormData.productName) {
                    callback(new Error('發文文號與產品名稱請擇一填寫'))
                } else {
                    callback()
                }
            },
            trigger: 'blur',
        },
    ],
    productName: [
        {
            validator: (rule, value, callback) => {
                if (!value && !progressFormData.unitPublishNumber) {
                    callback(new Error('發文文號與產品名稱請擇一填寫'))
                } else {
                    callback()
                }
            },
            trigger: 'blur',
        },
    ],
})
const submitForm = (formRef) => {
    formRef.validate((valid) => {
        if (valid) {
            let newQuery = {}
            Object.keys(progressFormData).forEach((key) => {
                if (progressFormData[key]) newQuery[key] = progressFormData[key]
            })

            router.push({
                path: router.currentRoute.value.path,
                query: newQuery,
            })
        } else {
            return false
        }
    })
}

let productStampItems = ref([])
async function initItems(query) {
    if (query.unitPublishNumber || query.productName) {
        productStampItems.value = await getProductStampData(query)
    }
}
initItems(route.query)
</script>
<style lang="scss" scoped>
#EnCycleBadgeProgress {
    @media screen and (min-width: 768px) {
        margin-bottom: 50px;
    }
}
#cycle-badge-progress-form {
    .el-form {
        margin: 30px auto 80px;
    }
    @media screen and (min-width: 768px) {
        .el-form {
            width: 50%;
        }
    }
}
.no-data {
    text-align: center;
    color: $grayB;
    font-size: 20px;
    font-weight: 900;
    margin: 20px 0 80px;
}
</style>
